import React from 'react';
export var AppealDetailPage = function () {
    return React.createElement("div", null);
};
